<template>
  <div class="d-flex justify-content-center align-items-center">
    <span v-for="star in starCount" :key="star" @click="setRating(star)" @mouseover="hoverRating(star)"
      @mouseleave="hoverRating(0)" :style="{ fontSize: `${starSize}px` }"
      :class="{
        'text-warning': star <= (hoveredRating || rating),
        'text-muted': star > (hoveredRating || rating),
        'cursor-pointer': !readonly,
        'scale-up': star <= (hoveredRating || rating)
      }">
      <svg :style="{ width: `${starSize}px`, height: `${starSize}px` }" xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 24 24" class="w-8 h-8">
        <path d="M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z"
          class="rounded-star" />
      </svg>
    </span>
  </div>
</template>

<script>
export default {
  name: 'StarRating',
  props: {
    rating: {
      type: Number,
      default: 0,
    },
    starCount: {
      type: Number,
      default: 5,
    },
    starSize: {
      type: Number,
      default: 24,
    },
    readonly: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      hoveredRating: 0,
    };
  },
  methods: {
    setRating(value) {
      if (this.readonly) return;
      this.$emit('input', value);
    },
    hoverRating(value) {
      if (this.readonly) return;
      this.hoveredRating = value;
    },
  },
};
</script>

<style scoped>
@keyframes wobble {
  0%, 100% {
    transform: rotate(-3deg);
  }

  50% {
    transform: rotate(3deg);
  }
}

.scale-up {
  animation: wobble 0.5s ease-in-out;
}

.rounded-star {
  border-radius: 4px;
}
</style>
